//#region Ticket

import { IChangeLog } from "./MiscelaneousClasses";

/**
 * Interface that matches both TicketTypes and TicketSubtypes
 */
export interface TicketTyping {
    description: string,
    id: number,
    invariantCultureDescription: string
}

export class Ticket {
    constructor(
        public contactEmail: string,
        public contactName: string,
        public contactTIN: string,
        public createdBy: string,
        public creationDate: Date,
        public id: number,
        public number: string,
        public relatedData: string,
        public relatedDataOrigin: string,
        public status: string,
        public supplierId: string,
        public type: number,
        public subtype: number
    ) {
    }
}
//#endregion

//#region Create Ticket
export class CreateTicket {
    associatedGroupName: string;
    contactPersonEmail: string;
    contactPersonFirstName?: string;
    contactPersonLastName?: string;
    contactPersonTIN?: string;
    message: CreateTicketMessage;
    supplierTicketNumber?: string;
    ticketSubtypeId?: number;

    constructor(
        associatedGroupName: string,
        contactPersonEmail: string,
        message: CreateTicketMessage,
        contactPersonFirstName?: string,
        contactPersonLastName?: string,
        contactPersonTIN?: string,
        supplierTicketNumber?: string,
        ticketSubtypeId?: number
    ) {
        this.associatedGroupName = associatedGroupName
        this.contactPersonEmail = contactPersonEmail
        this.message = message
        this.contactPersonFirstName = contactPersonFirstName
        this.contactPersonLastName = contactPersonLastName
        this.contactPersonTIN = contactPersonTIN
        this.supplierTicketNumber = supplierTicketNumber
        this.ticketSubtypeId = ticketSubtypeId
    }
}

export class AssociationTicketData {
    contractId?: number;
    electricitySupplyId?: number;
    entityId?: string;
    naturalGasSupplyId?: number;

    constructor(
        contractId?: number,
        electricitySupplyId?: number,
        entityId?: string,
        naturalGasSupplyId?: number
    ) {
        this.contractId = contractId;
        this.electricitySupplyId = electricitySupplyId;
        this.entityId = entityId;
        this.naturalGasSupplyId = naturalGasSupplyId;
    }

}

export class CreateTicketMessage {
    body: string;

    constructor(body: string) {
        this.body = body;
        
    }
}

export class CreateTicketFileMessage {
    file: File;
    typeId: number

    constructor(file: File, typeId: number) {
        this.file = file;
        this.typeId = typeId;
    }
}
//#endregion

// #region TicketMessage 
export interface ITicketMessage {
    body: string,
    files: TicketFile[],
    isSystemMessage: boolean,
    id?: number,
    picture?: string,
    readDate?: Date,
    creation: IChangeLog
}

export class TicketMessage {
    constructor(
        public body: string,
        public createdBy: string,
        public createdByName: string,
        public creationDate: Date,
        public files: TicketFile[],
        public isSystemMessage: boolean,
        public id?: number,
        public ticketId?: number,
        public picture?: string,
        public readDate?: Date,
        public sentDate?: Date,
        public errorOnSend: boolean = false
    ) {
    }

    public get sent(): boolean {
        return this.sentDate != null;
    }

    public get read(): boolean {
        return this.readDate != null;
    }
    
}

export class TicketFile
{   
    constructor(
        public blobName: string,
        public extension: string,
        public name: string,
        public path: string,
        public uploadDate: Date,
        public type?: string
    ) {}
}